import { BaseWebComponentView } from '../../framework/BaseWebComponentView';
import { PolicySelectorWebComponentSchema } from '../types/PolicySelectorWebComponentSchema';
import { ErrorDialogStrings } from '../../types';
import { translateFn } from '../../utils/translator.helper';

export class PoliciesSelectorView extends BaseWebComponentView {
  getDomElements() {
    this.dom.$wrapper = this.shadow.querySelector('.wrapper');
    this.dom.$policiesSelectorDropdown = this.shadow.querySelector('#policiesSelectorDropdown');

    this.getTranslations();
    this.setTranslatedStrings();
  }

  getTranslations() {
    this.commonStrings = this.stringsTranslator.getCommonStrings();
    this.translations = this.stringsTranslator.getPoliciesStrings();
  }

  setTranslatedStrings() {
    this.dom.$policiesSelectorDropdown.setAttribute('noResultsFound', this.commonStrings.noResultsFound);
    this.dom.$policiesSelectorDropdown.setAttribute('errorMessage', this.commonStrings.genericError);
  }

  buildSuccessView(data: PolicySelectorWebComponentSchema) {
    if (!data) {
      this.dom.$wrapper.innerHTML = '';
      return;
    }

    this.createDropdown(data);
  }

  createDropdown(data) {
    const { disabled, selectedTarget, list, excludePolicies } = data;
    this.dom.$policiesSelectorDropdown.disabled = disabled;

    const policiesOptions = list.map((availablePolicies, index) => {
      // don't display in selector the policies that have inheritance or are not editable
      if ((excludePolicies && availablePolicies.inheritsFrom) || !availablePolicies.isEditable) {
        return;
      }

      return {
        label: availablePolicies.label,
        value: index,
        selected: selectedTarget.indexOf(availablePolicies.value) >= 0,
      };
    }).filter(function(element) {
      return element !== undefined;
    });

    this.dom.$policiesSelectorDropdown.setAttribute('filterOptions', JSON.stringify(policiesOptions));
    this.dom.$policiesSelectorDropdown.setAttribute('value', selectedTarget.value || '');
    this.dom.$policiesSelectorDropdown.setAttribute('label', this.translations.policiesSelector.policies);
    this.dom.$policiesSelectorDropdown.setAttribute('labelWidth', '240');
    this.dom.$policiesSelectorDropdown.setAttribute('searchPlaceholderString', this.commonStrings.search);
    this.dom.$policiesSelectorDropdown.setAttribute('confirmActionButtonString', this.commonStrings.apply);
    this.dom.$policiesSelectorDropdown.setAttribute('noSearchResultsString', this.commonStrings.noResultsFound);
    this.dom.$policiesSelectorDropdown.setAttribute('listTitle', this.commonStrings.all);
    this.dom.$policiesSelectorDropdown.allowSelectNone = true;
  }

  clearInput() {
    this.dom.$policiesSelectorDropdown.clearInput();
  }

  public showErrorDialog(PoliciesName: string) {
    const dialogStrings = this.stringsTranslator.getDialogStrings();
    const { loadingErrorTitle, genericErrorMessage, confirm } = dialogStrings;
    const message = PoliciesName ? this.getPoliciesNameInSelectorErrorMessage(PoliciesName) : genericErrorMessage;

    const strings: ErrorDialogStrings = {
      title: loadingErrorTitle,
      message: message,
      actionButtonString: confirm,
    };

    this.buildDialogElement(strings);
  }

  private getPoliciesNameInSelectorErrorMessage(PolicyName: string): string {
    return translateFn(
      'An internal error occurred when selecting the policy {name}. Please try again later or contact Bitdefender Enterprise Support if the issue persists.',
      {
        name: PolicyName,
      }
    );
  }
}
